// Vendors
import React from 'react';
import axios from 'axios';
import { compact } from 'lodash';

// Components
import { GoogleMapsLoader } from './components';
import Locator from './components/Locator/Locator';

// Helpers
import { formatPhoneNumber, getStateAbbreviation } from '../lib/utilities';

const EquipmentDealerSearch = (props) => {
  let placesService = null;

  function handleGoogleMapsLoad() {
    placesService = new google.maps.places.PlacesService(
      document.createElement('div')
    );
  }

  function computeDistance(coordsA, coordsB) {
    return google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(coordsA[1], coordsA[0]),
      new google.maps.LatLng(coordsB[1], coordsB[0])
    );
  }

  function getDetails(placeId) {
    return new Promise((resolve, reject) => {
      // Details are included by default, so we can reject outright
      reject('Unable to find place details.');
    });
  }

  function searchNearby(coords, radius, callback) {
    const location = new google.maps.LatLng(coords[1], coords[0]);
    axios
      .get(
        `/wp-json/hubspot-companies/map/${radius}/${location.lat()}/${location.lng()}`
      )
      .then((response) => {
        const results = response.data.data;
        const places = results.map((result) => ({
          id: result.id,
          hasDetails: true,
          distance: null,
          location: [Number(result.longitude), Number(result.latitude)],
          dealerType: result.type_of_dealership,
          details: {
            formatted_address: compact([
              result.address,
              result.city,
              `${getStateAbbreviation(result.state)} ${result.zip}`
            ]).join(', '),
            formatted_phone_number: formatPhoneNumber(result.phone),
            name: result.name || null,
            opening_hours: null,
            website: result.website || null
          }
        }));
        callback(null, places);
      })
      .catch((error) => {
        callback('Unable to find places nearby.');
      });
  }

  return (
    <GoogleMapsLoader
      onLoad={handleGoogleMapsLoad}
      render={() => (
        <Locator
          computeDistance={computeDistance}
          getDetails={getDetails}
          hasRadialSearch={true}
          searchNearby={searchNearby}
          showFilters={true}
          defaultRadius="32000"
          {...props}
        />
      )}
    />
  );
};

export default EquipmentDealerSearch;
